module.exports = __webpack_public_path__ + "static/media/lawZebrasLogo.e7b20909.jpeg";